import React, { use, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../../../../hook/useAuth';
import { fetcher, fetcherPatch } from '../../../../../util/axios';
import { MatchingHistory } from '../../../../../types/matching';
import { FontWeightType, LabelMedium } from '../../../../../component/Text';
import { useMobile } from '../../../../../hook/usePlatform';
import { MainButton } from '../../../../../component/button';
import { formatName } from '../../../../../util/format';
import { getFromRecommendedUsers, getToRecommendUsers } from '../../../../../api/matchingHistoryAPI';
import { lineColor } from '../../../../../util/colors';

const RecommendMemberList:React.FC = () => {
  const [fromData, setFromData] = useState<MatchingHistory[]>([]);
  const [toData, setToData] = useState<MatchingHistory[]>([]);
  const isMobile = useMobile();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      getFromRecommendedUsers(user.memberId).then((r) => {
        setFromData(r);
      }).catch((e) => {
        console.error(e);
      });
      getToRecommendUsers(user.memberId).then((r) => {
        setToData(r);
      }).catch((e) => {
        console.error(e);
      });
    }
  }, [user]);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: isMobile ? '90%' : '50%' }}>
        {fromData.map((e) => (
          <RecommendMember
            isFrom
            key={`from_recommend_member_${e.matchingHistoryId}`}
            item={e}
          />
        ))}
        {toData.map((e) => (
          <RecommendMember
            isFrom={false}
            key={`to_recommend_member_${e.matchingHistoryId}`}
            item={e}
          />
        ))}
      </div>
    </div>
  );
};

const formatNumberZero = (num:number) => (`00${num}`).slice(-2);
const RecommendMember:React.FC<{ item:MatchingHistory, isFrom:boolean }> = (props) => {
  const border = `solid 1px ${lineColor}`;
  const navigate = useNavigate();
  const iamFrom = props.isFrom;
  const userInfo = props.item.member;
  const showDate = new Date(!iamFrom ? props.item.toMemberShowProfiledDt! : props.item.fromMemberShowProfiledDt);
  const expireDate = new Date(!iamFrom ? props.item.toMemberExpiredDt : props.item.fromMemberExpiredDt);
  const acceptState = iamFrom ? props.item.fromMemberAccept : props.item.toMemberAccept;
  const unAbleDetail =  acceptState === false || expireDate.getTime() < new Date().getTime();
  const isShow = showDate.getFullYear() > 1900;
  const toDetailPage = () => {
    navigate('/recommend/detail', { state: { user: userInfo, acceptState, historyId: props.item.matchingHistoryId } });
  };
  const imageSize = 90;

  if (!isShow) {
    return null;
  }

  return (
    <div style={{
      display: 'flex',
      gap: 16,
      marginBlock: 16,
      borderRadius: 16,
      border,
      paddingBlock: 16,
      paddingInline: 8,
    }}
    >
      <div style={{
        width: imageSize,
        height: imageSize,
        borderRadius: imageSize / 2,
        overflow: 'hidden',
      }}
      >
        <img src={userInfo.photos?.find((e) => e.main || e.isMain)?.url} alt="profile" style={{ width: imageSize, height: imageSize }} />
      </div>
      <div style={{ flex: 1 }}>

        <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>
          {formatName(userInfo.name)}
        </LabelMedium>
        <LabelMedium style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>
          (
          {userInfo.additionalInfo?.public?.birthday ? `${new Date(userInfo.additionalInfo?.public?.birthday).getFullYear()}년생 / ` : ''}
          {userInfo?.additionalInfo?.public?.address?.split(' ').slice(0, 2).join(' ')}
          )
        </LabelMedium>
        <div>
          <div style={{ display: 'flex' }}>
            <LabelMedium style={{ fontFamily: 'inter', flex: 1, color: '#444444' }}>
              추천일
            </LabelMedium>
            <LabelMedium style={{ fontFamily: 'inter', flex: 2, color: '#444444' }}>
              {showDate.getFullYear()}
              -
              {formatNumberZero(showDate.getMonth() + 1)}
              -
              {formatNumberZero(showDate.getDate())}
              {expireDate.getTime() < new Date().getTime() ? '(만료)' : ''}
            </LabelMedium>
          </div>
          <div style={{ display: 'flex' }}>
            <LabelMedium style={{ fontFamily: 'inter', flex: 1, color: '#444444' }}>
              진행상태
            </LabelMedium>
            <LabelMedium style={{ fontFamily: 'inter', flex: 2, color: acceptState ? '#32BB14' : '#444444' }}>
              {acceptState === null || acceptState === undefined ? '수락 전' : acceptState ? '수락' : '거부'}
            </LabelMedium>
          </div>

        </div>
        <MainButton
          text="자세히 보기"
          onPress={toDetailPage}
          disable={unAbleDetail}
          style={{ padding: 4, width: '100%', marginTop: 2  }}
        />
      </div>
    </div>
  );
};

export default RecommendMemberList;
